import React, { useState, useRef, useEffect } from 'react';
import { CouponItemInfo } from '../Components/CouponItemInfo';
import CouponDownload from '../Components/CouponDownload';
import useFetch from 'use-http';
import { exponeaCapture } from '@/components/hooks/exponeaCapture';
export default function CouponPaymentStep({ orderId }) {
  const [cartItem, setCartItem] = useState();
  const [fileGuids, setFileGuids] = useState();
  const [couponOrderId, setCouponOrderId] = useState();
  const [paymentPending, setPaymentPending] = useState();

  const { request: couponRequest } = useFetch(`/CouponManagement/CouponStatus`);

  const logResultInExponea = (status) => {
    let exponea = JSON.parse(sessionStorage.getItem('exponeaTrack') || '[]');
    exponea.push({ name: 'Registration status', value: status });
    exponea.push({
      name: 'booking_stage',
      value: status === 'Success' ? 'Booked & Paid' : 'Cancelled',
    });
    exponeaCapture(exponea, 'booking');
    sessionStorage.removeItem('exponeaTrack');
  };

  useEffect(() => {
    setPaymentPending(true);
    if (orderId) {
      couponRequest.get(`?couponOrderId=${orderId}`).then((res) => {
        if (
          res.paymentStatus === 'Paid' &&
          res.succeeded &&
          !res.waitingForFiles
        ) {
          setPaymentPending(false);
          setCartItem({
            price: res.price,
            comment: res.comment,
            title: res.couponTitle,
            orderedCount: res.orderedCount,
            validTo: res.validTo,
          });
          setFileGuids(res.fileGuids);
          logResultInExponea('Success');
        } else if (
          res.paymentStatus === 'Pending' ||
          res.fileGuids == null ||
          res.fileGuids.length === 0
        ) {
          setPaymentPending(true);
          let interval = window.setInterval(() => {
            couponRequest.get(`?couponOrderId=${orderId}`).then((res) => {
              if (!res.succeeded && res.fileGuids.length === 0) {
                // setShowEmptyFileModal(true);
                logResultInExponea('Failed');
              }
              if (res.paymentStatus === 'Paid' && res.fileGuids.length > 0) {
                setCartItem({
                  price: res.price,
                  comment: res.comment,
                  title: res.couponTitle,
                  orderedCount: res.orderedCount,
                  validTo: res.validTo,
                });
                setFileGuids(res.fileGuids);
                logResultInExponea('Success');
                setPaymentPending(false);

                clearInterval(interval);
              }
            });
          }, 3000);
        }
      });
    }
  }, [couponRequest, orderId]);

  return (
    <div class="flex flex-col md:flex-row gap-4 w-full">
      <div class="w-full md:w-1/2">
        <CouponDownload fileGuids={fileGuids}></CouponDownload>
      </div>
      <div class="w-full md:w-1/2">
        <CouponItemInfo
          name={cartItem?.title}
          price={cartItem?.price?.toFixed(2)}
          showQuantitySelector={false}
        ></CouponItemInfo>
      </div>
    </div>
  );
}
